export default async () => {
  await window.appInitializer.initPlanningApp()

  if (window.appInitializer.planningApp) {
    const ssrPlanning = document.querySelector("#ssr-planning")
    if (ssrPlanning) ssrPlanning.remove()
  }
}
